import { Routes } from '@angular/router';
import { adminClientGuard, adminGuard, authGuard, clientAdminGuard, clientGuard, noAuthGuard } from './core/guards/auth.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/layout/layout.component').then(m => m.LayoutComponent),
    canActivate: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'transports/history',
        pathMatch: 'full'
      },
      {
        path: 'dashboard',
        loadComponent: () => import('./pages/dashboard/dashboard').then(m => m.Dashboard)
      },
      {
        path: 'construction',
        loadComponent: () => import('./pages/construction/construction').then(m => m.Construction),
        data: { titleKey: 'navigation.drivers_incidents' }
      },
      {
        path: 'notifications',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/notifications/index').then(m => m.NotificationsComponent),
            data: { titleKey: 'navigation.notifications' }
          },
          {
            path: 'create',
            loadComponent: () => import('./pages/notifications/editor/editor.component').then(m => m.NotificationEditorComponent),
            data: { titleKey: 'notifications.editor.create_title' }
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./pages/notifications/editor/editor.component').then(m => m.NotificationEditorComponent),
            data: { titleKey: 'notifications.editor.edit_title' }
          },
          {
            path: 'view/:id',
            loadComponent: () => import('./pages/notifications/editor/editor.component').then(m => m.NotificationEditorComponent),
            data: { titleKey: 'notifications.editor.view_title', readonly: true }
          }
        ]
      },
      {
        path: 'noExist',
        loadComponent: () => import('./pages/statics/notExist/notexist').then(m => m.notExist)
      },
      {
        path: 'users',
        canActivate: [adminGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/users/users').then(m => m.Users)
          },

          {
            path: 'new',
            loadComponent: () => import('./pages/users/profile/profile').then(m => m.Profile)
          },
          {
            path: 'edit-user/:id',
            loadComponent: () => import('./pages/users/profile/profile').then(m => m.Profile)
          },
          {
            path: 'profile',
            loadComponent: () => import('./pages/users/profile/profile').then(m => m.Profile)
          },

        ]
      },
      {
        path: 'my',
        loadComponent: () => import('./pages/users-entities/users-entities-editor/users-entities-editor').then(m => m.UsersEntitiesEditor)
      },
      {
        path: 'drivers',
        canActivate: [adminGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/drivers/drivers.component').then(m => m.DriversComponent)
          },
          {
            path: 'create-driver',
            loadComponent: () => import('./pages/drivers/drivers-detail/driver-detail.component').then(m => m.DriverDetailComponent)
          },
          {
            path: 'edit-driver/:id',
            loadComponent: () => import('./pages/drivers/drivers-detail/driver-detail.component').then(m => m.DriverDetailComponent)
          }
        ]
      },
      {
        path: 'quality-management',
        canActivate: [adminGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/quality/quality-info-management.component').then(m => m.QualityInfoManagementComponent)
          },
          {
            path: 'incident/:id',
            loadComponent: () => import('./pages/quality/incident-management-view/incident-management-view.component').then(m => m.IncidentManagementViewComponent)
          }
        ]
      },
      {
        path: 'clients',
        canActivate: [adminGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/clients/clients').then(m => m.Clients)
          },
          {
            path: 'create-group',
            loadComponent: () => import('./pages/clients/group-manager/group-manager.view').then(m => m.GroupManagerView)
          },
          {
            path: 'edit-group/:id',
            loadComponent: () => import('./pages/clients/group-manager/group-manager.view').then(m => m.GroupManagerView)
          },
          {
            path: 'edit-client/:id',
            loadComponent: () => import('./pages/clients/create-client/edit-client').then(m => m.EditClient)
          },
          {
            path: 'create-client',
            loadComponent: () => import('./pages/clients/create-client/edit-client').then(m => m.EditClient)
          },
          {
            path: ':type',
            loadComponent: () => import('./pages/clients/clients').then(m => m.Clients)
          },
        ]
      },
      {
        path: 'transports',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/transports/transports').then(m => m.Transports)
          },
          {
            path: 'create',
            loadComponent: () => import('./pages/transports/manager-transport/selector-tranport-type/create-transport').then(m => m.CreateTransport)
          },
          {
            path: 'edit',
            loadComponent: () => import('./pages/transports/manager-transport/transport-editor/transport-editor').then(m => m.TransportEditorView)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./pages/transports/manager-transport/transport-editor/transport-editor').then(m => m.TransportEditorView)
          },
          {
            path: 'general-detail/:id',
            loadComponent: () => import('./pages/transports/general-detail/general-detail').then(m => m.GeneralDetail)
          },
          {
            path: 'budget-list/:id',
            loadComponent: () => import('./pages/transports/components/transports-assignment/budget-list/budget-list/budget-list').then(m => m.BudgetList)
          },

          {
            path: 'incident-form',
            loadComponent: () => import('./pages/quality/incident-form/incident-form').then(m => m.IncidentForm)
          },
          {
            path: 'additional-costs',
            canActivate: [adminGuard],
            loadComponent: () => import('./pages/additional-costs/additional-costs.component').then(m => m.AdditionalCostsComponent)
          },
          {
            path: 'driver-invoices',
            canActivate: [adminGuard],
            loadComponent: () => import('./pages/driver-invoices/driver-invoices.component').then(m => m.DriverInvoicesComponent)
          },
          {
            path: 'driver-invoices/:id',
            canActivate: [adminGuard],
            loadComponent: () => import('./pages/invoice-detail-driver-clients/invoice-detail.component').then(m => m.InvoiceDetailComponent),
            data: { invoiceType: 'driver' }
          },
          {
            path: 'create-driver-invoices',
            canActivate: [adminGuard],
            loadComponent: () => import('./pages/create-driver-invoices/create-driver-invoices.component').then(m => m.CreateDriverInvoicesComponent)
          },
          {
            path: 'client-invoices',
            canActivate: [adminClientGuard],
            loadComponent: () => import('./pages/client-invoices/client-invoices.component').then(m => m.ClientInvoicesComponent)
          },
          {
            path: 'client-invoices/transport-detail/:transportId',
            canActivate: [adminClientGuard],
            loadComponent: () => import('./pages/client-invoice-transport-detail/client-invoice-transport-detail.component').then(m => m.ClientInvoiceTransportDetailComponent)
          },
          {
            path: 'client-invoices/:id',
            canActivate: [adminClientGuard],
            loadComponent: () => import('./pages/invoice-detail-driver-clients/invoice-detail.component').then(m => m.InvoiceDetailComponent),
            data: { invoiceType: 'client' }
          },
          {
            path: 'budget-over-transport/:id',
            loadComponent: () => import('./pages/transports/budget-over-transport/budget-over-transport').then(m => m.BudgetOverTransport)
          },
          {
            path: ':tab',
            loadComponent: () => import('./pages/transports/transports').then(m => m.Transports)
          },
        ]
      },
      {
        path: 'regularizations',
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/regulations/regulations-list/regulations-list').then(m => m.RegulationsList)
          },

          {
            path: 'list/:type/:id',
            loadComponent: () => import('./pages/regulations/regulations-list/regulations-list').then(m => m.RegulationsList)
          },
          {
            path: 'create',
            loadComponent: () => import('./pages/regulations/regulations-editor/regulations-editor').then(m => m.RegulationsEditor)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./pages/regulations/regulations-editor/regulations-editor').then(m => m.RegulationsEditor)
          }
        ]
      },
      {
        path: 'users-clients-entities',
        canActivate: [clientAdminGuard],
        children: [
          {
            path: '',
            loadComponent: () => import('./pages/users-entities/users-entities').then(m => m.UsersEntities)
          },
          {
            path: 'create',
            loadComponent: () => import('./pages/users-entities/users-entities-editor/users-entities-editor').then(m => m.UsersEntitiesEditor)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./pages/users-entities/users-entities-editor/users-entities-editor').then(m => m.UsersEntitiesEditor)
          }
        ]
      },
      {
        path: 'addresses',
        children: [
          {
            path: '',
            canActivate: [clientGuard],
            loadComponent: () => import('./pages/addresses/addresses-list/addresses-list').then(m => m.AddressesList)
          },
          {
            path: 'create',
            loadComponent: () => import('./pages/addresses/address-editor/address-editor').then(m => m.AddressEditor)
          },
          {
            path: 'edit/:id',
            loadComponent: () => import('./pages/addresses/address-editor/address-editor').then(m => m.AddressEditor)
          }
        ]
      }

    ]
  },

  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
    canActivate: [noAuthGuard]
  },
  {
    path: 'resetpassword',
    loadComponent: () => import('./pages/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: '**',
    loadComponent: () => import('./pages/statics/notExist/notexist').then(m => m.notExist),
  }
];
